module.exports = __webpack_public_path__ + "static/media/main2.9e7c2eb5.png";